export const COOKIE_KEYS = {
  TOKEN: 'jwtToken',
  AUTH_CODE: 'authCode',
  PARAMS: 'parameters',
  GOOGLE_ANALYTICS: '_ga',
  CXD_AFFILIATES: 'cxd',
  LANGUAGE: 'language',
}

export const PARAMS_COOKIE_KEYS = {
  USER_ID: 'userId',
  OWNER: 'owner',
  ACCOUNT_ID: 'accountId',
  ACCOUNT_NAME: 'accountName',
  NETWORK_ID: 'networkId',
  SUBSCRIPTION_ID: 'subscriptionId',
  IS_ADMIN: 'isAdmin',
  IS_REACTIVATION: 'isReactivation',
}

const keys = Object.values(PARAMS_COOKIE_KEYS)

export type ParamCookieType = Record<(typeof keys)[number], string>
